import { render, staticRenderFns } from "./ErrorPage403.vue?vue&type=template&id=67507ec8&scoped=true"
import script from "./ErrorPage403.vue?vue&type=script&lang=js"
export * from "./ErrorPage403.vue?vue&type=script&lang=js"
import style0 from "./ErrorPage403.vue?vue&type=style&index=0&id=67507ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67507ec8",
  null
  
)

export default component.exports